<template>
    <div v-if="calculatedTile" class="theme-page" ref="imgContainer" id="img-container">

        <img ref="tileImage" @load="onImageLoadFinished" :src="fileResourceUrl(tile.tile.value.image)"
             alt="stage image"/>

        <div v-if="isDesktop">
            <div v-bind:key="index" v-for="(pin,index) in tile.tile.value.pinList">
                <pb-theme-pin
                        v-if="pin.adjustedY && pin.adjustedX"
                        :pin="pin"
                        :id="tile.identifier.value + '-' + index"/>
            </div>
        </div>
        <div v-else-if="pageArticles && pageArticles.length > 0">
            <b-button ref="mox"  v-b-modal="'modal-' + tile.identifier.value" class="btn-mobile-popup">
                {{ $t("theme_mobile_show_products_btn") }} &nbsp;
                <i class="fal fa-inline fa-chevron-up"></i>
            </b-button>

            <!--mobile-->
            <b-modal @shown="modalVisible = true" @hidden="modalVisible = false"  hide-header hide-footer centered ok-only :id="'modal-' + tile.identifier.value">
                <pb-carousel v-if="modalVisible">
                    <router-link
                            :to="{name: 'ar', params: {articleId: article.id, categoryId: 1500, variantId: article.colorId, cardId: article.cardId}}"
                            class="card-deck category-card-deck my-3 mr-3" :key="index"
                            v-for="(article,index) in pageArticles">
                        <pb-card style="width:275px;"
                                 :img-src="article.thumbnail">
                            <template slot="content">
                                <span class="d-block">{{article.description}}</span>
                            </template>
                        </pb-card>
                    </router-link>
                </pb-carousel>
            </b-modal>
        </div>
    </div>
</template>

<script>

    import ThemePin from "./ThemePin";
    import {mapGetters} from "vuex";

    export default {
        name: 'pb-theme-page',
        props: {
            tile: {
                type: Object
            },
        },
        mounted() {
        },
        components: {
            'pb-theme-pin': ThemePin
        },
        data() {
            return {
                modalVisible: false,
                calculatedTile: this.tile.tile ? this.tile.tile : null
            }
        },
        computed: {
            ...mapGetters('media', ['isDesktop']),
            pageArticles: function () {
                let pinList = this.tile.tile.value.pinList,
                    res = [];

                if (pinList) {
                    this.tile.tile.value.pinList.forEach(pin => {
                        res = res.concat(pin.articleList)
                    });
                }

                return res;
            }
        },
        methods: {
            onImageLoadFinished() {
                this.onResize();

                window.addEventListener('resize', this.onResize);
            },
            onResize() {
                this.$nextTick(function () {
                    let imgContainer = this.$refs.imgContainer,
                        tileImage = this.$refs.tileImage;

                    if (imgContainer && tileImage) {
                        for (let z = 0; z < this.tile.tile.value.pinList.length; z++) {
                            let fitSize = this.getObjectFitSize(false, imgContainer.clientWidth, imgContainer.clientHeight, tileImage.naturalWidth, tileImage.naturalHeight),
                                predefinedY = Number(this.tile.tile.value.pinList[z].y),
                                predefinedX = Number(this.tile.tile.value.pinList[z].x),
                                coverReplacementY = Math.abs(Number(fitSize.y)),
                                coverReplacementX = Math.abs(Number(fitSize.x));

                            this.$set(this.tile.tile.value.pinList[z], 'adjustedY', Math.round(((predefinedY / 100) * fitSize.height) - coverReplacementY));
                            this.$set(this.tile.tile.value.pinList[z], 'adjustedX', Math.round(((predefinedX / 100) * fitSize.width) - coverReplacementX));
                        }
                    }
                })

            }
        },
    }

</script>

<style lang="scss" scoped>
    .theme-page {
        position: relative;
        display: inline-block;
        height: 100%;
        width: 100%;


        .slider-card {
            width: 275px;
        }

        .wrapper {
            position: absolute;
            bottom: 10%;
            left: 0;
            right: 0;
            margin: auto;
            text-align: center;
        }

        .btn-mobile-popup {
            margin: auto;
            border-radius: 5px;
            border: 1px solid transparent;
            padding: 0 40px;
            background: white;
            box-shadow: 0px 0 10px rgba(0, 0, 0, 0.3);
            color: black;
            cursor: pointer;
            font-weight: bold;

            &:hover, &:focus, &:active {
                background: white !important;
                color: black !important;
            }
        }

        img {
            height: 100%;
            width: 100%;
            margin: auto;
            object-fit: cover;
        }
    }
</style>